module.exports = __webpack_public_path__ + "media/images/pro_subscription/carousel3-haircut-en-GB@3x-5533327c5e2731a2251a9e39076bc7bf.png";